import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'de';
  });

  const t = translations[currentLang] || translations.ar;

  useEffect(() => {
    localStorage.setItem('language', currentLang);
    document.documentElement.dir = t.dir;
    document.documentElement.lang = currentLang;
  }, [currentLang, t.dir]);

  const changeLang = (langCode) => {
    setCurrentLang(langCode);
  };

  return (
    <LanguageContext.Provider value={{ currentLang, t, changeLang }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
